import PropTypes from 'prop-types';
import React from 'react';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { Iterable } from 'immutable';
import { EmailCell, StatusCell, DateCell } from './CellFormatters.react';

export default class JobTable extends React.Component {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.rowCount = this.rowCount.bind(this);
  }

  onSelect({ index }) {
    this.props.onSelect(this.props.jobs.get(index));
  }

  rowCount() {
    if (this.props.jobs) {
      return this.props.jobs.size;
    }

    return 0;
  }

  render() {
    return (
      <div className='tableContainer jobTable'>
        <AutoSizer>
          {({ height, width }) => (
            <Table
              height={height}
              width={width}
              rowGetter={({ index }) => this.props.jobs.get(index)}
              rowCount={this.rowCount()}
              rowHeight={50}
              headerHeight={50}
              onRowClick={this.onSelect}
              className='mainTable'
              scrollingResetTimeInterval={50}
              rowClassName={({ index }) => {
                const job = this.props.jobs.get(index);
                return (job && job.id === this.props.selectedId) ? 'selected' : null;
              }}
            >
              <Column
                width={100}
                label='Status'
                dataKey='status'
                flexShrink={0}
                cellRenderer={StatusCell}
              />
              <Column
                width={200}
                label='Job Name'
                dataKey='name'
                flexGrow={4}
                cellDataGetter={({ rowData, dataKey }) => (rowData[dataKey])}
              />
              <Column
                width={125}
                flexGrow={1}
                label='Started By'
                dataKey='creator'
                cellRenderer={EmailCell}
              />
              <Column
                width={200}
                label='Time Started'
                dataKey='startedAt'
                cellRenderer={DateCell}
                cellDataGetter={({ rowData, dataKey }) => (rowData[dataKey])}
              />
            </Table>
          )}
        </AutoSizer>
      </div>
    );
  }
}

JobTable.propTypes = {
  selectedId: PropTypes.string,
  jobs: PropTypes.instanceOf(Iterable),
  onSelect: PropTypes.func,
};
